var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHokNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24.16,
    viewBox: "0 0 24 24.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9,20.47a.78.78,0,0,0-.93.58,2,2,0,0,1-3.93,0,.78.78,0,1,0-1.51.35,3.57,3.57,0,0,0,7,0A.78.78,0,0,0,14.9,20.47Z",
    fill: "#e30613"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.49,13.09a1.18,1.18,0,0,1-.35-.84V10a8.15,8.15,0,0,0-5.47-7.69,2.69,2.69,0,0,0-5.33,0A8.15,8.15,0,0,0,3.86,10v2.2a1.18,1.18,0,0,1-.35.84L2.12,14.48a2.23,2.23,0,0,0-.66,1.59v2.42a.78.78,0,0,0,.78.78h0l9.76,0h9.76a.78.78,0,0,0,.78-.78V16.07a2.24,2.24,0,0,0-.66-1.59Zm.5,4.62H3V16.07a.69.69,0,0,1,.21-.49l1.39-1.39a2.72,2.72,0,0,0,.8-1.94V10a6.59,6.59,0,0,1,4.87-6.36.78.78,0,0,0,.58-.75V2.69a1.13,1.13,0,1,1,2.27,0v.25a.78.78,0,0,0,.58.75A6.59,6.59,0,0,1,18.59,10v2.2a2.72,2.72,0,0,0,.8,1.94l1.39,1.39a.71.71,0,0,1,.2.49Z",
    fill: "#e30613"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHokNotification);
export default __webpack_public_path__ + "static/media/hok-notification.38ab7d05c52b05625db060b1acbab479.svg";
export { ForwardRef as ReactComponent };